import { useState } from "react";
import { Stack } from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import { useNavigate } from "react-router-dom";
import BuyVoucherTab from "../BuyVoucherTab";
import UseVoucherTab from "../UseVoucherTab";
import TightTabs from "../../../Common/components/TightTabs";
import { Vouchers, VoucherType } from "@/services/core-api-adapter";
import { defaultFullscreenPageStyling } from "@/theme";

interface AddOrUseVoucherPageProps {
  voucher: Vouchers | undefined;
  onDoctorNurseConsultationVoucherClicked: (voucher: VoucherType) => void;
  onPathologyTestVoucherClicked: (voucher: VoucherType) => void;
}

export default function AddOrUseVoucherPage({
  voucher,
  onPathologyTestVoucherClicked,
  onDoctorNurseConsultationVoucherClicked,
}: AddOrUseVoucherPageProps) {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<string>("buy-voucher");
  const matchedLocations = location.pathname.split("/");
  const labels = [
    "AddOrUseVoucher.Voucher.BuyVoucherTab.title",
    "AddOrUseVoucher.Voucher.UseVoucherTab.title",
  ];

  function onBackButtonClick() {
    navigate("/");
  }
  return (
    <Stack spacing={2} sx={{ ...defaultFullscreenPageStyling }}>
      <CircledBackButton showLabel={true} onClick={onBackButtonClick} />

      <Stack spacing={3}>
        <TightTabs
          selectedTab={selectedTab}
          baseRoute="/home/my-vouchers"
          matchedLocations={matchedLocations}
          setSelectedTab={setSelectedTab}
          labels={labels}
        />

        {selectedTab === "buy-voucher" && (
          <BuyVoucherTab
            voucher={voucher}
            onDoctorNurseConsultationVoucherClicked={
              onDoctorNurseConsultationVoucherClicked
            }
            onPathologyTestVoucherClicked={onPathologyTestVoucherClicked}
          />
        )}
        {selectedTab === "use-voucher" && <UseVoucherTab />}
      </Stack>
    </Stack>
  );
}
